import { render, staticRenderFns } from "./AdminHome.vue?vue&type=template&id=4be7455b&"
import script from "./AdminHome.ts?vue&type=script&lang=ts&"
export * from "./AdminHome.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports